"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapLabels = exports.defaultIgnoredLabelKeys = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _internal = require("../utils/internal");
var _constants = require("./constants");
const defaultIgnoredLabelKeys = exports.defaultIgnoredLabelKeys = {
  deal: [_presentationComponents.NEW_EDITION, _presentationComponents.OFFER],
  ppa: []
};
const mapLabels = (collection, ignoredLabelKeys) => {
  if (collection) {
    const dealIgnoredKeys = ignoredLabelKeys?.deal ?? defaultIgnoredLabelKeys.deal;
    const ppaIgnoredKeys = ignoredLabelKeys?.ppa ?? defaultIgnoredLabelKeys.ppa;
    const deal = collection.find(label => (0, _internal.findLabelByDomainType)(_constants.LABEL_DEAL)(label) && !dealIgnoredKeys.includes(label?.labelKey ?? ''));
    const ppa = collection.find(label => (0, _internal.findLabelByDomainType)(_constants.LABEL_PPA)(label) && !ppaIgnoredKeys.includes(label?.labelKey ?? ''));
    return {
      deal: {
        helpText: deal?.helpText ?? null,
        labelKey: deal?.labelKey ?? null,
        title: deal?.title ?? null
      },
      ppa: {
        helpText: ppa?.helpText ?? null,
        labelKey: ppa?.labelKey ?? null,
        title: ppa?.title ?? null
      }
    };
  }
  return null;
};
exports.mapLabels = mapLabels;
//# sourceMappingURL=mapLabels.js.map